import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";

export default function DataSetActionsView() {
  const { datasetId } = useParams(); // route: /actions/bydataset/view/:datasetId
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      { label: "#", type: "count", value: "__count", width: "48px", align: "center" },
      { label: "Name", value: "name", search: "name", width: "220px" },
      { label: "Type", value: "type", search: "type", width: "140px" },
      { label: "Landing Page", value: "landingPageName", search: "landingPageName", width: "220px" },
      { label: "Card Design", value: "cardDesignName", search: "cardDesignName", width: "220px" },
      { label: "Printer Group",  value: "printerGroupId.name" },
      {
        label: "Status",
        value: "status",
        width: "120px",
        type: "render",
        render: (r) => (r.status === "active" ? "Active" : "Inactive"),
      },
      {
        label: "Updated",
        value: "updatedAt",
        width: "160px",
        type: "render",
        render: (r) => (r.updatedAt ? new Date(r.updatedAt).toLocaleString() : ""),
      },
    ],
    []
  );

  return (
    <div>
      <div className="datatable-container compact" style={{ marginBottom: 8 }}>
        <div
          className="datatable-header-row"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}
        >
          <h2 style={{ margin: 0 }}>Actions (View)</h2>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn" onClick={() => navigate("/actions")}>Return</button>
            <button className="btn-gold" onClick={() => navigate(`/actions/bydataset/edit/${datasetId}`)}>Manage</button>
          </div>
        </div>
      </div>

      <SmartDataTable
        key={`view-actions-${datasetId}`}
        config={{
          columns,
          queryName: "/actions/listByDataSet",
          pageSize: 20,
          fixedFilters: { datasetId }, // sent in POST body
          buttons: [], // read-only view
        }}
      />
    </div>
  );
}
